import React from "react";
import { Box, Paper, Typography } from "@mui/material";

/**
 * BulkActionsBar
 * A lightweight banner shown above a DataGrid when rows are selected.
 * Props:
 * - count: number of selected rows
 * - onClear: optional callback to clear selection
 * - children: action buttons to render on the right
 */
export function BulkActionsBar({ count = 0, onClear, children, sx }) {
  if (!count) return null;
  return (
    <Paper
      elevation={0}
      sx={{
        px: 3,
        py: 1.5,
        mx: 3,
        mb: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderRadius: 1,
        bgcolor: (theme) =>
          theme.palette.mode === "dark"
            ? "rgba(144,202,249,0.08)"
            : "rgba(25,118,210,0.06)",
        border: (theme) =>
          `1px solid ${
            theme.palette.mode === "dark" ? "#2a3f5f" : "rgba(25,118,210,0.2)"
          }`,
        ...sx,
      }}
    >
      <Typography variant="body1" sx={{ fontWeight: 600 }}>
        {count} geselecteerd
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        {children}
      </Box>
    </Paper>
  );
}

export default BulkActionsBar;
